import { type SourceType } from './props-source';

export const sourceSymbol = Symbol('source');
export const previousSourceSymbol = Symbol('previousSource');
export const themeValueKeySymbol = Symbol('themeValueKey');
export const unsetDetectedSymbol = Symbol('unsetDetected');

/**
 * Per-path provenance of a merge, mirroring the merged value's shape. Symbol keys hold the
 * metadata for the current path; string keys recurse into it. This is what lets the
 * properties editor show where a value came from and offer to revert an override.
 */
export interface MergedPropsMetadata {
  [sourceSymbol]?: SourceType | null;
  [previousSourceSymbol]?: SourceType | null;
  [themeValueKeySymbol]?: string;
  [unsetDetectedSymbol]?: boolean;
  [key: string]: MergedPropsMetadata | undefined;
}

/** The symbol-keyed entries of {@link MergedPropsMetadata}, as a plain readable object. */
export interface MergedPropsMetadataEntry {
  source?: SourceType | null;
  previousSource?: SourceType | null;
  themeValueKey?: string;
  unsetDetected?: boolean;
}

export interface MetadataMergeResult<T = any> {
  value: T;
  metadata: MergedPropsMetadata;
}

export function getPropsMetadataEntry(
  metadata: MergedPropsMetadata | null | undefined,
): MergedPropsMetadataEntry {
  return {
    source: metadata?.[sourceSymbol],
    previousSource: metadata?.[previousSourceSymbol],
    themeValueKey: metadata?.[themeValueKeySymbol],
  };
}
